import { create } from "zustand";

interface BreadcrumbStore {
  templates: string[];
  setTemplates: (templates: string[]) => void;
}

export const breadcrumbStore = create<BreadcrumbStore>((set) => ({
  templates: [],
  setTemplates: (templates: string[]) => set({ templates }),
}));
